import { $convertFromMarkdownString } from '@lexical/markdown';
import type { InitialConfigType } from '@lexical/react/LexicalComposer';
import { EDITOR_TRANSFORMER, EditorConfigNodes, getTransformedMarkdown } from '../utils/utils';
import useEditorTheme from './useEditorTheme';
const NAMESPACE = 'lexical-rich-text-editor';
type EditorConfigParamsType = {
  initialText: string;
  readOnly?: boolean;
};
const useEditorConfig = ({
  initialText,
  readOnly
}: EditorConfigParamsType): {
  editorConfig: InitialConfigType;
} => {
  const editorTheme = useEditorTheme();
  const editorConfig: any = {
    namespace: NAMESPACE,
    onError(error: Error) {
      throw error;
    },
    editable: !readOnly,
    theme: editorTheme,
    nodes: EditorConfigNodes
  };
  if (initialText) {
    editorConfig.editorState = () => {
      const transformedMarkdown = getTransformedMarkdown(initialText);
      $convertFromMarkdownString(transformedMarkdown, EDITOR_TRANSFORMER);
    };
  }
  return {
    editorConfig
  };
};
export default useEditorConfig;